import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import Hero from "./HPComponents/HP_Hero/HP_Hero";
import HP_PlatformFeatures from "./HPComponents/HP_PlatformFeatures/HP_PlatformFeatures";
import EventsSection from "./HPComponents/HP_Events/EventsSection";
import "./home.css";

const HomePage = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);
  const { user } = useContext(UserContext);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="homepage">
      {/* Hero Section */}
      <section className="hp-section hp-section--hero">
        <Hero />
      </section>

      {/* Events Section - Future & Past */}
      <EventsSection />

      {/* Platform Features Section */}
      <section className="hp-section hp-section--features">
        <div className="container">
          <HP_PlatformFeatures />
        </div>
      </section>

      {/* Join the Community CTA */}
      <section className="hp-section hp-section--join-cta">
        <div className="container">
          <div className="hp-join-cta">
            <h2 className="hp-join-cta__title">Join the Community!</h2>
            <p className="hp-join-cta__text">
              The first platform where dancers rate festivals honestly, celebrate
              each other anonymously, and shape a safer global dance community together.
            </p>
            {user ? (
              <Link to="/festivals" className="hp-join-cta__button">
                Explore Events
              </Link>
            ) : (
              <Link to="/login?tab=signup" className="hp-join-cta__button">
                Create an Account
              </Link>
            )}
          </div>
        </div>
      </section>

      {/* Scroll to Top */}
      <button
        className={`scroll-to-top ${showScrollTop ? 'visible' : ''}`}
        onClick={scrollToTop}
        aria-label="Scroll to top"
      >
        <i className="bi bi-chevron-up"></i>
      </button>
    </div>
  );
};

export default HomePage;
